// extracted by mini-css-extract-plugin
module.exports = {"poolsPage":"Pools_poolsPage__2iM88","content":"Pools_content__2Zzuv"};